import { i18n, Row, Form, DivButton, utils, http } from '@common';
import { useRef, useState, useEffect, useCallback } from 'react';
import { CISInput } from '../input/input';
import './loginStudentID.less';
import { routerPaths } from '../../oauth/tool';
import { redirectTransferTo, transferToRetrieve } from '../../utils/utils';
import { studentIdService } from '@api';

const LoginStudentID = (props) => {
    const { onlyStudentId } = props;
    const [showDisable, setShowDisable] = useState(false);
    const [inputStudentValue, setInputStudentValue] = useState();
    const [studentIdInputValidate, setStudentIdInputValidate] = useState(false);
    const formRef = useRef();
    const showDisableCheckRef = useRef();
    const transferData = JSON.parse(sessionStorage['transferData'] || null);
    const emailLogicalName = transferData?.detail?.EmailOTP?.logicalName;
    const params = utils.geturlparam(window?.location.search);
    const { obj } = params;

    useEffect(() => {
        const pageInput = document.querySelector("#inputCommon");
        document.addEventListener('keyup', (e) => {
            let timer = null;
            if (timer) { clearTimeout(timer); }
            timer = setTimeout(() => {
                if (e.key === 'Enter' && pageInput && pageInput === document.activeElement) {
                    let subData = null;
                    setInputStudentValue(inputItem => {
                        subData = inputItem;
                        return inputItem;
                    });
                    signinEvent(subData);
                }
            }, 200);
        });
    }, [signinEvent]);

    const handleInputChange = (value) => {
        setInputStudentValue(value);
    };

    const handleButtonClick = (way) => {
        if (way === 'retrieve') {
            window.wogaaCustom?.startTransactionalService('cispoliteedu-4706');
        } else if (way === 'enable') {
            window.wogaaCustom?.startTransactionalService('cispoliteedu-4705');
        }
        utils.redirectTo(routerPaths.retrieve.oprateStudentId.compile({ way: way }));
    };
    const handleSectionClick = (from) => {
        if (from === 'retrieveEmailOTP') {
            window.wogaaCustom?.startTransactionalService('cispoliteedu-4706');
            transferToRetrieve(emailLogicalName, from, obj?.proxyState);
        } else if (from === 'enable') {
            window.wogaaCustom?.startTransactionalService('cispoliteedu-4705');
            redirectTransferTo(emailLogicalName, from);
        }
    };
    const signinEvent = useCallback((StudentValue = null) => {
        if (!formRef.current.validate()) {
            setStudentIdInputValidate(true);
            return;
        }
        $$.loading(true);
        studentIdService.IsUserEnabled({ upn: inputStudentValue || StudentValue }).then((res) => {
            if (res.errorCode !== http.ErrorStatus.Successed) {
                showDisableCheckRef.current = true;
                formRef.current.validate();
            } else {
                showDisableCheckRef.current = false;
                setShowDisable(false);
                const emailLogin = JSON.parse(sessionStorage.getItem('transferData') || null);
                const azureADLogicalName = emailLogin?.detail?.AzureAD?.logicalName;
                const onlyInputId = inputStudentValue?.split('@')[0] || '';
                window.wogaaCustom?.completeTransactionalService('cispoliteedu-4703');
                redirectTransferTo(azureADLogicalName, '', onlyInputId);
            }
        }).finally(_ => {
            $$.loading(false);
        });
    }, [inputStudentValue]);

    const studentIdValidate = (value) => {
        setShowDisable(false);
        const reg = /^\d{7}[a-zA-Z]$/;
        if (!value) {
            setStudentIdInputValidate(true);
            return i18n.get('CIS_Home_Tab_StudentId_CheckNull_Entry');
        } else if ((value.length > 8 && !$$.type.isEmail(value)) || !reg.test(value?.split('@', 1)[0])) {
            setStudentIdInputValidate(true);
            return i18n.get('CIS_Home_Tab_StudentId_CheckFromat_Entry');
        } else if (showDisableCheckRef.current) {
            setShowDisable(true);
            showDisableCheckRef.current = false;
            return ' ';
        }
        return true;
    };

    return (
        <>
            <Form style={{ width: '480px', margin: '0 auto' }} ref={formRef} className={onlyStudentId ? 'form student-id-login only-student-id' : 'form student-id-login'}>
                <Row className="font-bold" style={{ fontSize: '24px', marginTop: '5%' }}>{onlyStudentId ? i18n.get('CIS_Home_Tab_OnlyStudentId_SigninTitle_Entry') : i18n.get('CIS_Home_Tab_StudentId_SigninTitle_Entry')}</Row>
                <Row
                    validation={{
                        type: "input",
                        valFunction: studentIdValidate,
                    }}
                >
                    <CISInput
                        iconClassName={'fia-user-id-card-white'}
                        placeholder={i18n.get('CIS_Home_Tab_StudentId_Input_Placeholder_Entry')}
                        hasButton={false}
                        isChangeRed={studentIdInputValidate || showDisable}
                        onChange={handleInputChange}
                    ></CISInput>
                </Row>
                {showDisable &&
                    <Row className="row-signin-validation" style={{ marginTop: '4px' }}>
                        <span>{i18n.get('CIS_Home_StudentId_Signin_ValidationPrev_Message')}</span>
                        <a onClick={() => onlyStudentId ? handleSectionClick('enable') : handleButtonClick('enable')}>{i18n.get('CIS_Home_StudentId_Signin_ValidationLink_Message')}</a>
                        <div>{i18n.get('CIS_Home_StudentId_Signin_ValidationNext_Message')}</div>
                    </Row>}
                <Row style={{ borderRadius: '8px' }} >
                    <R.Button
                        text={i18n.get('CIS_Home_Tab_StudentId_SigninButton_Entry')}
                        classify='info'
                        block
                        attrs={{ 'style': 'border-radius: 8px;  height: 42px; font-size:18px' }}
                        onClick={signinEvent}
                    />
                </Row>
            </Form>
            <div className={onlyStudentId ? 'emailOtpLinkBoxStudentID only-student-id-box' : 'emailOtpLinkBoxStudentID'}>
                <div className='emailOtpLinkMessageStu'>
                    <DivButton id="retrieve-button" type="link" style={{ fontSize: '18px' }} onClick={() => onlyStudentId ? handleSectionClick('retrieveEmailOTP') : handleButtonClick('retrieve')}>
                        {i18n.get('CIS_Home_Tab_StudentId_RetrieveStudentID_Entry')}
                    </DivButton>
                </div>
            </div>
            <div className={`${onlyStudentId ? 'only-studentid-instruction' : 'no-padding'}`} >
                <Row className="student-login-instruction" style={{ width: '484px' }}>
                    {onlyStudentId ?
                        <span>
                            <div className='font-bold' style={{ fontSize: '18px' }}>{i18n.get('CIS_Home_Tab_InstructionTitle_Entry')}</div>
                            <div style={{ fontSize: '16px', color: "#A0A0A0" }}>{i18n.get('CIS_Home_Tab_StudentId_Instruction_OnlyStudentId_Message')}</div>
                        </span> :
                        <span>
                            <div className='font-bold' style={{ fontSize: '18px' }}>{i18n.get('CIS_Home_Tab_InstructionTitle_Entry')}</div>
                            <div style={{ fontSize: '16px', color: "#A0A0A0", marginBottom: '8px' }}>{i18n.get('CIS_Home_Tab_StudentId_Instruction_One_Message')}</div>
                            <div style={{ fontSize: '16px', color: "#A0A0A0", marginBottom: '8px' }}>{i18n.get('CIS_Home_Tab_StudentId_Instruction_Two_Message')}</div>
                            <div style={{ fontSize: '16px', color: "#A0A0A0" }}>{i18n.get('CIS_Home_Tab_StudentId_Instruction_Three_Message')}</div>
                        </span>}
                </Row>
            </div>
        </>
    );
};
export default LoginStudentID;